export const useShippingSearchFooter = () => {
  return {};
};
